export const authPl = {
  auth: {
    login: 'Zaloguj się',
    logout: 'Wyloguj się',
    register: 'Załóż konto',
    email: 'Email',
    password: 'Hasło',
    password_confirm: 'Potwierdź hasło',
    forgot_password: 'Zapomniałeś hasła?',
    reset_password: 'Resetuj hasło',
    change_password: 'Zmień hasło',
    remember_me: 'Zapamiętaj mnie',
    login_success: 'Zalogowano pomyślnie',
    logout_success: 'Wylogowano pomyślnie',
    register_success: 'Rejestracja zakończona sukcesem. Sprawdź email i potwierdź konto.',
    verify_email_required: 'Przed kontynuacją musisz potwierdzić adres email.',
    invalid_credentials: 'Nieprawidłowy email lub hasło',
    already_have_account: 'Masz już konto?',
    dont_have_account: 'Nie masz konta?',
    sign_in: 'Zaloguj się',
    sign_up: 'Załóż konto',
    sign_in_to_account: 'Zaloguj się do swojego konta',
    create_account: 'Utwórz nowe konto',
    current_password: 'Obecne hasło',
    new_password: 'Nowe hasło',
    new_password_confirm: 'Potwierdź nowe hasło',
    password_changed: 'Hasło zostało zmienione',
    reset_link_sent: 'Link do resetowania hasła został wysłany na Twój email',
    send_reset_link: 'Wyślij link',
    back_to_login: 'Powrót do logowania',
    reset_token: 'Token resetowania',
    reset_code: 'Kod resetowania',
    email_placeholder: 'twoj.email@example.com',
    password_requirements: 'Hasło musi mieć co najmniej 8 znaków',
    token_placeholder: 'Wprowadź token z emaila',
    enter_new_password: 'Wprowadź nowe hasło',
    login_with_google: 'Kontynuuj z Google',
    links: {
      or_create_account: 'Lub utwórz nowe konto',
      create_new_account: 'Utwórz nowe konto',
      or_sign_in: 'Masz już konto?',
      sign_in_existing: 'Zaloguj się do istniejącego konta',
    },
    official_form: {
      title: 'Zaloguj się',
      description: 'Wpisz email i hasło, aby uzyskać dostęp do konta',
      forgot_password_link: 'Zapomniałeś hasła?',
      logging_in: 'Logowanie...',
      login_with_google: 'Kontynuuj z Google',
      no_account: 'Nie masz konta?',
      sign_up_link: 'Załóż konto',
    },
    form: {
      name: 'Imię i nazwisko',
      name_placeholder: 'Wprowadź swoje imię i nazwisko',
      email_placeholder: 'Wprowadź swój email',
      password_placeholder: 'Wprowadź swoje hasło',
      password_confirm_placeholder: 'Potwierdź swoje hasło',
      current_password_placeholder: 'Wprowadź obecne hasło',
      new_password_placeholder: 'Wprowadź nowe hasło',
      new_password_confirm_placeholder: 'Potwierdź nowe hasło',
      submit_login: 'Zaloguj się',
      submit_register: 'Utwórz konto',
      submit_reset: 'Wyślij link resetujący',
      submit_reset_password: 'Resetuj hasło',
      submit_change_password: 'Zmień hasło',
    },
    forgot_password_page: {
      title: 'Zapomniałeś hasła?',
      subtitle: 'Wprowadź swój adres email, a wyślemy Ci link do zresetowania hasła.',
      back_to_login: 'Powrót do logowania',
    },
    reset_password_page: {
      title: 'Ustaw nowe hasło',
      subtitle: 'Wprowadź nowe hasło poniżej',
      back_to_login: 'Powrót do logowania',
    },
    change_password_page: {
      title: 'Zmień hasło',
      subtitle: 'Zaktualizuj hasło do swojego konta',
    },
    two_factor: {
      title: 'Uwierzytelnianie dwuskładnikowe',
      subtitle: 'Dodaj dodatkową warstwę bezpieczeństwa do swojego konta',
      verification_success: 'Weryfikacja pomyślna',
      verify_button: 'Zweryfikuj',
      no_methods_configured: 'Brak skonfigurowanych metod 2FA',
      setup: {
        title: 'Konfiguracja uwierzytelniania dwuskładnikowego',
      },
      verify: {
        title: 'Uwierzytelnianie dwuskładnikowe',
      },
      totp: {
        title: 'Aplikacja uwierzytelniająca (TOTP)',
        tab_label: 'TOTP',
        description: 'Użyj aplikacji uwierzytelniającej takiej jak Google Authenticator lub Authy',
        setup: 'Skonfiguruj aplikację uwierzytelniającą',
        cancel: 'Anuluj',
        disable: 'Wyłącz TOTP',
        disable_confirm: 'Czy na pewno chcesz wyłączyć uwierzytelnianie TOTP?',
        disable_success: 'Uwierzytelnianie TOTP zostało wyłączone',
        enabled: 'Uwierzytelnianie TOTP włączone',
        enabled_description: 'Twoja aplikacja uwierzytelniająca jest skonfigurowana i aktywna',
        disabled: 'TOTP jest wyłączone',
        scan_qr_code: 'Skanuj kod QR',
        scan_qr_code_description: 'Zeskanuj ten kod QR za pomocą swojej aplikacji uwierzytelniającej',
        manual_entry: 'Lub wprowadź kod ręcznie:',
        copy_secret: 'Kopiuj sekret',
        secret_copied: 'Sekret skopiowany do schowka',
        scan_instructions: 'Zeskanuj kod QR za pomocą swojej aplikacji uwierzytelniającej (Google Authenticator, Authy, itp.)',
        scan_step_title: 'Krok 1: Skanuj kod QR',
        scan_step_description: 'Użyj swojej aplikacji uwierzytelniającej, aby zeskanować poniższy kod QR',
        continue_to_verify: 'Przejdź do weryfikacji',
        verify_step_title: 'Krok 2: Zweryfikuj kod',
        verify_step_description: 'Wprowadź 6-cyfrowy kod z aplikacji uwierzytelniającej',
        code_label: '6-cyfrowy kod',
        code_placeholder: '000000',
        verify_button: 'Zweryfikuj i włącz',
        setup_complete: 'Konfiguracja TOTP zakończona',
        setup_success: 'Uwierzytelnianie TOTP włączone pomyślnie',
        backup_codes: 'Kody zapasowe',
        backup_codes_description: 'Zapisz te kody zapasowe w bezpiecznym miejscu. Możesz ich użyć, aby uzyskać dostęp do konta, jeśli zgubisz urządzenie.',
        backup_codes_warning: 'Każdy kod zapasowy może być użyty tylko raz. Przechowuj je bezpiecznie.',
        invalid_code: 'Nieprawidłowy kod. Spróbuj ponownie.',
        enter_code_help: 'Wprowadź 6-cyfrowy kod z aplikacji uwierzytelniającej',
      },
      webauthn: {
        title: 'Klucze dostępu',
        tab_label: 'Klucze dostępu',
        description: 'Użyj uwierzytelniania biometrycznego lub kluczy bezpieczeństwa',
        register: 'Zarejestruj klucz dostępu',
        register_title: 'Dodaj nowy klucz dostępu',
        register_description: 'Zarejestruj nowy klucz dostępu używając uwierzytelniania biometrycznego urządzenia lub klucza bezpieczeństwa',
        register_success: 'Klucz dostępu zarejestrowany pomyślnie',
        verify: 'Użyj klucza dostępu',
        verify_instruction: 'Kliknij przycisk poniżej, aby uwierzytelnić się za pomocą klucza dostępu',
        passkey_name: 'Nazwa klucza dostępu',
        passkey_name_placeholder: 'np. iPhone, Laptop, YubiKey',
        passkey_name_help: 'Nadaj kluczowi dostępu nazwę, aby łatwiej go później zidentyfikować',
        no_passkeys: 'Brak zarejestrowanych kluczy dostępu',
        registered_passkeys: 'Zarejestrowane klucze dostępu',
        passkeys_description: 'Zarządzaj swoimi kluczami dostępu',
        last_used: 'Ostatnio użyty',
        created: 'Utworzony',
        name: 'Nazwa',
        delete: 'Usuń',
        delete_confirm: 'Czy na pewno chcesz usunąć ten klucz dostępu?',
        delete_success: 'Klucz dostępu usunięty pomyślnie',
        add_passkey: 'Dodaj nowy klucz dostępu',
        user_cancelled: 'Uwierzytelnianie anulowane',
        not_supported: 'Klucze dostępu nie są obsługiwane na tym urządzeniu',
      },
      verify_page: {
        title: 'Zweryfikuj swoją tożsamość',
        subtitle: 'Proszę zweryfikować się używając jednej z metod 2FA',
        choose_method: 'Wybierz metodę weryfikacji',
      },
    },
    verify_email: {
      title: 'Potwierdź swój adres email',
      subtitle: 'Dokończ weryfikację, aby odblokować wszystkie funkcje.',
      instructions: 'Wysłaliśmy wiadomość z linkiem weryfikacyjnym. Kliknij link w emailu, by potwierdzić konto.',
      resend_label: 'Nie otrzymałeś wiadomości? Wyślij link ponownie.',
      resend_helper: 'Wyślemy nową wiadomość na poniższy adres email.',
      resend_button: 'Wyślij ponownie link weryfikacyjny',
      back_to_login: 'Wróć do logowania',
      go_to_app: 'Przejdź do panelu',
      email_required: 'Adres email jest wymagany, aby ponownie wysłać link.',
      invalid_or_expired: 'Link weryfikacyjny jest nieprawidłowy lub wygasł. Poproś o nowy poniżej.',
      success: 'Adres email został pomyślnie zweryfikowany.',
      redirecting_to_dashboard: 'Przekierowywanie do panelu...',
      redirecting_to_login: 'Przekierowywanie do logowania...',
    },
    pages: {
      login: 'Logowanie',
      register: 'Rejestracja',
      verifyEmail: 'Weryfikacja email',
      oauthCallback: 'OAuth Callback',
    },
    oauth: {
      button: {
        continue_with_google: 'Google',
        continue_with_facebook: 'Facebook',
        continue_with_github: 'GitHub',
        redirecting: 'Przekierowywanie...',
      },
      or_continue_with: 'Lub kontynuuj z',
      callback: {
        signing_in: 'Logowanie...',
        processing: 'Przetwarzanie uwierzytelniania {provider}. Proszę czekać...',
        authentication_failed: 'Uwierzytelnianie nie powiodło się',
        cancelled_or_denied: 'Uwierzytelnianie OAuth zostało anulowane lub odrzucone',
        invalid_parameters: 'Nieprawidłowe parametry OAuth',
        invalid_state: 'Nieprawidłowy parametr state - możliwy atak CSRF',
        failed: 'Uwierzytelnianie OAuth nie powiodło się',
        success: 'Pomyślnie zalogowano za pomocą {provider}',
        two_factor_required: 'Wymagane uwierzytelnianie dwuskładnikowe',
        not_configured: 'Google OAuth nie jest skonfigurowane',
        failed_to_initiate: 'Nie udało się zainicjować logowania',
      },
    },
  },
}
